import React from 'react';
import { BaasicInput, BaasicDropdown, Loader } from 'core/components';
import _ from 'lodash';
import { defaultTemplate } from 'core/hoc';
import { translate } from 'core/utils';

const LookupEditTemplate = ({ modalParams, lookupEditViewStore: { form, loading } }) => {
	if (loading) return <Loader />;

	return (
		<form className="ReactModal__form" onSubmit={form.onSubmit}>
			<div className="ReactModal__header">
				<h3 className="spc--bottom--sml">
					{translate(
						getModalTitle(
							modalParams.data.rootStore.routerStore.routerState.queryParams['create'] !== undefined,
							modalParams.data.selectedLookup.parameters.itemName
						)
					)}
				</h3>
			</div>
			<div className="ReactModal__body">
				<div className="row">
					{form.has('name') && (
						<div className="col col-sml-12">
							<BaasicInput autoFocus field={form.$('name')} />
						</div>
					)}
					<div className="col col-sml-12 col-med-12">{getExtraFields(form.fields.data_)}</div>
				</div>
				{form.error && (
					<div>
						<p className="type--color--warning spc--bottom--sml">{translate(form.error)}</p>
					</div>
				)}
			</div>
			<div className="ReactModal__footer">
				<button className="btn btn--med btn--primary spc--bottom--sml" type="submit">
					{loading ? (
						<div className="spinnercont spc--right--sml">
							<div className="spinner"></div>
						</div>
					) : null}
					{translate('SAVE')}
				</button>
			</div>
		</form>
	);
};

const getExtraFields = dataMap => {
	return [...dataMap]
		.filter(item => item[0] !== 'name')
		.map(([key, value]) => {
			return value.value_.dropdownStore ? (
				<div className="spc--bottom--sml flex--grow--1" key={value.value_.key}>
					<BaasicDropdown dropdownStore={value.value_.dropdownStore} />
				</div>
			) : (
				<div className="col col-sml-12" key={value.value_.key}>
					<BaasicInput key={value.value_.key} field={value.value_} />
				</div>
			);
		});
};

const getModalTitle = (isCreate, itemName) => {
	return `${isCreate ? translate('CREATE') : translate('EDIT')} ${translate(_.startCase(itemName))}`;
};

export default defaultTemplate(LookupEditTemplate);



// WEBPACK FOOTER //
// ./src/themes/default/modules/lookup/pages/LookupEditTemplate.jsx